import { useMemo } from 'react';

import { useStringFeatureFlag } from '@confluence/session-data';
import { useIsLivePage } from '@confluence/live-pages-utils/entry-points/useIsLivePage';
import { is1PMacro } from '@confluence/fabric-extension-lib/entry-points/macroClassificationUtils';
import { fg } from '@confluence/feature-gating';

import { EXTENSION_OVERLAY_REMOVAL_LIST_FF } from './legacy-macro-constants';

export const useShouldHideOverlay = (extensionKey: string, isBodiedExtension: boolean): boolean => {
	const isLivePage = useIsLivePage();
	const extensionsToHideOverlays = useStringFeatureFlag(EXTENSION_OVERLAY_REMOVAL_LIST_FF) ?? '';

	const shouldHide: boolean = useMemo(() => {
		if (!extensionKey || !extensionsToHideOverlays) {
			return false;
		}

		if (extensionsToHideOverlays === 'ALLOW_ALL' || isLivePage) {
			return true;
		}

		const is2PNonBodied = !is1PMacro(extensionKey) && !isBodiedExtension;
		if (is2PNonBodied && fg('confluence_disable_macro_overlay_for_2p_nonbodied')) {
			return true;
		}

		const extensionKeys = extensionsToHideOverlays
			.split(',')
			.map((ext) => ext.trim().toLowerCase());

		return extensionKeys.includes(extensionKey.toLowerCase());
	}, [extensionKey, extensionsToHideOverlays, isLivePage, isBodiedExtension]);

	return shouldHide;
};
